import { ImageConfigEntry, ImageConfigResponse } from '../base-api';
import { TranslateService } from '@ngx-translate/core';

export class AppImageConfig {

  private imageConfig;

  constructor(formatConfigResponse: ImageConfigResponse,
              private translateService: TranslateService) {
    this.imageConfig = formatConfigResponse;
  }

  getImageFormatForCurrentLanguage(type: ImageConfigEntry.TypeEnum): ImageConfigEntry {
    if (this.imageConfig) {
      return this.imageConfig.entries.find(a => a.type === type && a.languages.indexOf(this.translateService.getCurrentLang()) >= 0);
    }
  }

}
